<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('businessName')">
          <el-select
            v-model="queryForm.businessCode"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <template v-for="(item, i) in businessList">
              <el-option-group
                v-if="item.parentId == 0"
                :key="i"
                :label="$t(item.name)"
              >
                <template v-for="(t, i2) in businessList">
                  <el-option
                    v-if="t.parentId == item.id"
                    :key="i2"
                    :label="$t(t.name)"
                    :value="t.businessCode"
                  ></el-option>
                </template>
              </el-option-group>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="false"
            :picker-options="pickerOptions0"
            @change="changeDate"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
          >
            <i class="el-icon-search"></i> {{ $t("query") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          min-width="50"
        />

        <el-table-column
          prop="amount"
          :label="$t('amount')"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span
            >{{ Number(scope.row.amount).formatMoney(0) }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="isDetail"
          prop="businessName"
          :label="$t('businessName')"
          min-width="200"
        >
          <template slot-scope="scope">{{
            $t(scope.row.businessName)
          }}</template>
        </el-table-column>

        <el-table-column
          prop="orgCode"
          :label="$t('orgCode')"
          min-width="160"
        />
        <el-table-column
          prop="orgName"
          :label="$t('orgName')"
          min-width="160"
        />

        <el-table-column
          prop="sourceRemunerationAmount"
          :label="$t('sourceRemunerationAmount')"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span
            >{{ scope.row.sourceRemunerationAmount.formatMoney(0) }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="isDetail"
          prop="customerName"
          :label="$t('customerName')"
          min-width="200"
        />

        <el-table-column
          prop="transactionCode"
          :label="$t('transactionCode')"
          min-width="200"
        />

        <el-table-column
          v-if="isDetail"
          :label="$t('tradeAssistant')"
          min-width="200"
        >
          <template slot-scope="scope">
            {{
              (scope.row.creatorName || "") +
                " " +
                (scope.row.creatorSurname || "")
            }}
            ({{ scope.row.employeeId || scope.row.createId }})
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{
              $manba(scope.row.createTime).format(
                queryForm.type == 2 || queryForm.type == 3 ? "ymd" : "ymdhms"
              )
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
  </el-card>
</template>

<script>
import remunerationStatistics from "@/api/remunerationStatistics";
import business from "@/api/business";

export default {
  name: "RemunerationAgents",
  data() {
    return {
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: time => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        }
      },
      isLoading: false,
      queryTableHeight: String,
      tableData: {},
      pageSize: 20,
      currentPage: 1,
      queryForm: {
        type: 1,
        date: [new Date(this.$manba().format("ym") + "-01"), new Date()]
      },
      businessList: [],
      isDetail: true
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    globalTotalAmount() {
      if (!this.tableData.records || !this.tableData.records.length) return "0";
      return this.tableData.records
        .reduce((sum, row) => sum + Number(row.amount || 0), 0)
        .formatMoney(0);
    },
    globalTotalSourceRemuneration() {
      if (!this.tableData.records || !this.tableData.records.length) return "0";
      return this.tableData.records
        .reduce(
          (sum, row) => sum + Number(row.sourceRemunerationAmount || 0),
          0
        )
        .formatMoney(0);
    }
  },
  watch: {
    "queryForm.type"(val) {
      this.isDetail = val == 1;
    },
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = newVal[0];
        this.queryForm.endTime = newVal[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    }
  },
  methods: {
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
      }
    },

    getList() {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));

      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      }
      delete params.date;

      remunerationStatistics.remunerationDetailed({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ...params
        },
        success: res => {
          _this.isLoading = false;
          _this.tableData = res.data || {};
        }
      });
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    getBusiness() {
      business.getList({
        success: res => {
          this.businessList = (res.data || []).reverse();
          this.getList();
        }
      });
    }
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getBusiness();
  }
};
</script>

<style></style>
